export const ETHIZO_PRACTICE_ID = "111";

export const OAKMED_PRACTICE_ID = "320";

export const SIXTY_TWO_PRACTICE_ID = "114";

export const SENIOR_HEALTH_SUPPORT = "1238";